class Translator {
  constructor() {
    // Define supported languages first
    this.supportedLanguages = ['en', 'da', 'de'];
    
    // Then get default language
    this.translations = {};
    this.currentLanguage = this.getDefaultLanguage();
  }

  async init() {
    try {
      const response = await fetch('/i18n/translations.json');
      this.translations = await response.json();
      this.setLanguage(this.currentLanguage);
      return true;
    } catch (error) {
      console.error('Failed to load translations:', error);
      return false;
    }
  }

  getDefaultLanguage() {
    // Try to get from localStorage
    const stored = localStorage.getItem('language');
    if (stored && this.supportedLanguages.includes(stored)) {
      return stored;
    }

    // Try to get from browser language
    const browserLang = navigator.language.split('-')[0].toLowerCase();
    if (this.supportedLanguages.includes(browserLang)) {
      return browserLang;
    }

    // Default to English
    return 'en';
  }

  setLanguage(lang) {
    if (this.supportedLanguages.includes(lang)) {
      this.currentLanguage = lang;
      localStorage.setItem('language', lang);
      document.documentElement.lang = lang;
      return true;
    }
    return false;
  }

  get(key, placeholders = {}) {
    const keys = key.split('.');
    let value = this.translations[this.currentLanguage];

    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        console.warn(`Translation key not found: ${key}`);
        return key;
      }
    }

    // Replace placeholders like {count}
    if (typeof value === 'string') {
      Object.entries(placeholders).forEach(([placeholder, replacementValue]) => {
        value = value.replace(`{${placeholder}}`, replacementValue);
      });
    }

    return value || key;
  }

  t(key, placeholders) {
    return this.get(key, placeholders);
  }

  getLanguages() {
    return this.supportedLanguages;
  }

  getCurrentLanguage() {
    return this.currentLanguage;
  }
}

// Create global instance
const i18n = new Translator();

export { i18n, Translator };
